import { render, staticRenderFns } from "./group.vue?vue&type=template&id=4bc3ce24&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc3ce24",
  null
  
)

export default component.exports